import React, { useEffect } from 'react'
import { EventHubData } from '../../../Api'
import { FAQsCon, MapImgCon } from './styles'
import { GamificationSummary } from '../../../Components/Gamification/GamificationSummary'
import { Desc, Head2 } from '../../../Components/Typography/Text.styles'
import { colors } from '../../../Components/consts'
import { Box } from '../../../Components/Layout'

type GamedayParms = {
  hubInfo: EventHubData | null
}

export const Gameday: React.FC<React.PropsWithChildren<GamedayParms>> = ({
  hubInfo,
}) => {
  useEffect(() => {}, [])

  return (
    <Box boxColor={colors.darkBackground}>
      {hubInfo?.venueMap && (
        <MapImgCon>
          <img src={hubInfo.venueMap} alt="Venue Map" />
        </MapImgCon>
      )}
      <GamificationSummary />
      <Head2 textColor={colors.white}>Event Info</Head2>
      {hubInfo?.gateLocations && (
        <>
          {hubInfo?.gateTimes && (
            <Desc vertMargins={1.5} textColor={colors.gray.gray20}>
              {' '}
              <strong>Gate Times: </strong>
              {hubInfo.gateTimes}
            </Desc>
          )}
          {hubInfo?.gateLocations && (
            <Desc vertMargins={1.5} textColor={colors.gray.gray20}>
              <strong>Gate Locations: </strong>
              {hubInfo.gateLocations}
            </Desc>
          )}
          {hubInfo.premierZoneTimes && (
            <Desc vertMargins={1.5} textColor={colors.gray.gray20}>
              <strong>Premier Zone: </strong>
              {hubInfo.premierZoneTimes}
            </Desc>
          )}
          {hubInfo.boxOfficeLocation && (
            <Desc vertMargins={1.5} textColor={colors.gray.gray20}>
              <strong>Box Office Location: </strong>
              {hubInfo.boxOfficeLocation}
            </Desc>
          )}
        </>
      )}
      {hubInfo?.eventFAQ && (
        <>
          <Head2 vertMargins={1.5} textColor={colors.white}>
            {' '}
            Event FAQs
          </Head2>
          <FAQsCon dangerouslySetInnerHTML={{ __html: hubInfo.eventFAQ }} />
        </>
      )}
    </Box>
  )
}
